import { render, staticRenderFns } from "./teacher-diagnosis-view.vue?vue&type=template&id=f48ee216&"
import script from "./teacher-diagnosis-view.vue?vue&type=script&lang=js&"
export * from "./teacher-diagnosis-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports